import Util from 'util/util'

/**
 * saveEmail
 *
 * Saves a corrected email address and sends new login credentials to it. A teacher can do this for one of
 * their students by passing the studentId, otherwise the email of the user itself is saved. Shows a status
 * message for every outcome.
 *
 * @param  {string} email - The corrected email address
 * @param  {number} [studentId] - Id of the student whose email is corrected by their teacher
 * @returns {Promise<string>} Resolves with 'saved', 'already-valid', 'in-use' or 'error'
 */
export default function saveEmail(email, studentId = null) {
    const data = {
        email,
        resend_credentials: true
    }

    if (studentId) {
        data.studentId = studentId
    }

    return new Promise((resolve) => {
        jQuery.post('/users/save_email.json', data, (response) => {
            if (response?.status === 'success') {
                Backbone.View.layout.openStatus(window.i18n.sprintf(
                    window.i18n.gettext('The email address has been saved and new login credentials have been sent to %s.'),
                    Util.stripTags(email)
                ), 'success')
                resolve('saved')
            } else if (response?.message === 'email already in use') {
                Backbone.View.layout.openStatus(window.i18n.gettext(
                    'This email address is already in use, please enter an other email address.'
                ))
                resolve('in-use')
            } else if (response?.message === 'email already valid') {
                Backbone.View.layout.openStatus(window.i18n.gettext(
                    'This student\'s email has already been changed.'
                ), 'warning')
                resolve('already-valid')
            } else {
                Backbone.View.layout.openStatus(window.i18n.gettext(
                    'Something went wrong with saving your email, please try again'
                ))
                resolve('error')
            }
        }).fail(() => resolve('error'))
    })
}
